<mat-card *ngIf="detailResponse">
  <div fxLayout="row" fxLayoutAlign="center start">
    <a mat-icon-button class="back" routerLink="../">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <div fxFlex>
      <mat-card-title fxLayout="row">
        <div>{{detailResponse.product}}</div>
        <div fxFlex></div>
        <div fxLayout="column" class="dates">
          <strong>Fecha de publicación</strong>
          <span *ngFor="let dt of detailResponse.publishDates">{{dt | date: 'MMM dd yyyy '}}</span>
        </div>
      </mat-card-title>
    </div>
  </div>
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="row-document"
      *ngFor="let item of detailResponse.data">
      <ng-container *ngIf="item.displayTitle; else elseTemplate">
        <strong fxFlex="20">{{item.name}}</strong>
        <div fxFlex="80" [innerHTML]="item.value"></div>
      </ng-container>
      <ng-template #elseTemplate>
        <div fxFlex="100" [innerHTML]="item.value"></div>
      </ng-template>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <form fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="10px" [formGroup]="sendForm">
      <mat-form-field fxFlex="100" fxFlex.md="calc(50% - 10)" fxFlex.lg="30">
        <mat-select placeholder="Fecha" name="item" formControlName="selectedDate">
          <mat-option *ngFor="let item of detailResponse.publishDates" [value]="item">
            {{item | date: 'MMM dd yyyy'}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field fxFlex="100" fxFlex.md="auto" fxFlex.lg="auto">
        <input type="email" matInput placeholder="Email" formControlName="email">
      </mat-form-field>
      <!-- <div fxFlex></div> -->
      <button mat-raised-button *ngIf="!downloadingPDF"  (click)="downloadCert(detailResponse.id, sendForm.get('selectedDate').value)" [disabled]="detailResponse.publishDates.length > 1 && !sendForm.get('selectedDate').value">
        Descargar PDF
      </button>
      <div *ngIf="downloadingPDF" >
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
      <button mat-raised-button *ngIf="!sendingEmail"
              (click)="sendEmailCert(detailResponse.id, sendForm.get('email').value, sendForm.get('selectedDate').value)"
              [disabled]="certEmailSent || !sendForm.get('email').valid || (detailResponse.publishDates.length > 1 && !sendForm.get('selectedDate').value)">
        {{certEmailSent ? 'Correo Enviado' : 'Enviar Correo'}}
      </button>
      <div *ngIf="sendingEmail" >
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
    </form>
  </mat-card-actions>
  <embed #embedpdf [hidden]="!showCertPDFIframe" width="100%" height="0" type="application/pdf">
</mat-card>
